import { Box, Collapse, Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { StudyAreaIcon } from "@nens/ranalib";

import { AddIconControl } from "@/components/add-icon-control";
import { RanaMap } from "@/lib/rana-map";

import { LayerFromFileTooltip } from "../../components/from-file-tooltip";

import { AddStudyAreaModal } from "./components/add-study-area-modal";
import { RemoveStudyAreaDialog } from "./components/remove-study-area-dialog";
import { StudyAreaHeaderActions } from "./components/study-area-header-actions";
import { useStudyAreaControl } from "./hooks/use-study-area-control";

export function StudyAreaControl() {
  const {
    isAddModalOpen,
    isRemoveModalOpen,
    studyArea,
    tooltipLabel,
    isEditable,
    openAddModal,
    closeAddModal,
    openRemoveModal,
    closeRemoveModal,
  } = useStudyAreaControl();

  return (
    <Collapse in={isEditable || !!studyArea} unmountOnExit>
      <LayerFromFileTooltip label={tooltipLabel}>
        <Box borderBottomWidth="base" borderColor="brand.glacier" pb={3}>
          {isAddModalOpen && <AddStudyAreaModal close={closeAddModal} />}
          {isRemoveModalOpen && studyArea && (
            <RemoveStudyAreaDialog layer={studyArea} close={closeRemoveModal} />
          )}

          <RanaMap.ControlsHeader pt={3} pr={studyArea ? 3 : undefined}>
            <Flex role="group" justify="space-between" align="center" w="full">
              <Flex align="center" gap={2}>
                <StudyAreaIcon color="brand.sky" />
                <FormattedMessage id="publication.study_area.header" defaultMessage="Study area" />
              </Flex>
              <Flex align="center" gap={2}>
                {!studyArea && isEditable && <AddIconControl onClick={openAddModal} />}

                {studyArea && (
                  <StudyAreaHeaderActions layer={studyArea} onRemoveStudyArea={openRemoveModal} />
                )}
              </Flex>
            </Flex>
          </RanaMap.ControlsHeader>
        </Box>
      </LayerFromFileTooltip>
    </Collapse>
  );
}
